export enum PermissionDeniedPropsVariant {
  SOLID = 'solid',
  TRANSLUCENT = 'translucent',
  DARK = 'dark',
}

export interface PermissionDeniedProps {
  showTitle: boolean;
  showSubTitle: boolean;
  variant: PermissionDeniedPropsVariant;
  noIcon: boolean;
}
